import { Box } from "@material-ui/core";

import { GraphsView } from "./GraphsView";
import { SolarReport } from "../../../../api/Quote/SolarReport";
import { useBreakpoint } from "../../../../hooks/useBreakpoint";
import { useStyles } from "../../quoteDetail.styles";

const Graphs = ({ solarReportData }: { solarReportData: SolarReport | null }) => {
  return <GraphsView solarReportData={solarReportData} />;
};

export const GraphsSection = ({
  solarReportData,
  isSolar
}: {
  solarReportData: SolarReport | null;
  isSolar?: boolean;
}) => {
  const classes = useStyles();
  const { isMoreThanSm } = useBreakpoint();
  if (!isSolar) return null;
  if (solarReportData === null) return null;
  // if (Number(solarReportData.electricityEstimatedAnnualSpend) <= 0) return null;
  return (
    <Box mt={"82px"} mb={"142px"}>
      <Box
        textAlign={"center"}
        fontSize={isMoreThanSm ? "28px" : "20px"}
        color={"#1e073f"}
        fontWeight={500}
        width={"100%"}
      >
        Turn your roof into your own personal power plant
        {isMoreThanSm && <br />}
        <span className={classes.colorOrange}> and {!isMoreThanSm && <br />}generate free electricity for life!</span>
      </Box>
      <Graphs solarReportData={solarReportData} />
    </Box>
  );
};
